// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_ed8a979","content":"_73581b0"};